import React from 'react';

const DoctorPanel = () => {
    return (
        <div>
            <h1>Doctor panel page</h1>
        </div>
    );
};

export default DoctorPanel;